const restclient = require('nordic/restclient');
const LandingUtils = require('../../../../utils/landing');

const request = restclient({
  baseURL: '',
  timeout: 12000,
});

module.exports = {
  path: '/developers/:lang/docs/*',
  exact: false,
  resolve: () => require.ensure([], require => require('../docsPage/view'), 'docs.chunk'),
  webpack: () => require.resolveWeak('../docsPage/view'),
  fetchData: (params, state, history) => {
    let endpoint = `/${params.lang}`;
    endpoint += params.l1 ? `/${params.l1}` : '';
    endpoint += params.l2 ? `/${params.l2}` : '';
    endpoint += params.l3 ? `/${params.l3}` : '';
    endpoint += params.l4 ? `/${params.l4}` : '';
    endpoint += params.l5 ? `/${params.l5}` : '';
    endpoint += params['0'] ? `/${params['0']}` : '';

    const actualUrl = {
      host: `https://${window.location.host}`,
      path: history.location.pathname,
      fullPath: history.location.pathname + history.location.search,
    };

    const responseTemplate = {
      actualUrl,
      lang: params.lang,
      landing: false,
      content: null,
      notfound: false,
    };

    const landing = LandingUtils.getLanding(`/${params.lang}/docs${endpoint.replace(`/${params.lang}`, '')}`);
    if (landing) {
      return {
        ...responseTemplate,
        landing,
      };
    }

    return request.get(`/developers/api/guides${endpoint}`)
      .then((response) => ({
        ...responseTemplate,
        content: response?.data?.content,
        notfound: !response?.data?.content,
      }))
      .catch((err) => {
        console.log(err);
        return {
          ...responseTemplate,
          notfound: true,
        };
      });
  },
};
